module.exports = __webpack_public_path__ + "img/Eyes 90.03805780.png";